// --- React & Redux
import React from 'react';
import { useSelector } from 'react-redux';
// --- Components
import { DetailsModal } from 'datastage/components/DetailsModal';
import { SavedTemplatesGrid } from './grid';
// --- Hooks & Actions
import { useTemplatesActions } from 'datastage/store/templates/useTemplates';

/**
 * Saved Templates Modal
 *
 * Features:
 * - Displays a modal with a grid of saved templates
 * - Allows users to view and manage their saved templates
 *
 * @returns {Element}
 * @constructor
 */
export const SavedTemplatesModal = () => {
    const { isSavedTemplatesOpen } = useSelector((state) => state.templates);
    const { updateTemplates } = useTemplatesActions();

    const onCloseModal = () => {
        updateTemplates({
            isSavedTemplatesOpen: false,
        });
    };

    return (
        <DetailsModal
            isOpen={isSavedTemplatesOpen}
            onClose={onCloseModal}
            modalHeader="My Saved Templates"
        >
            <SavedTemplatesGrid />
        </DetailsModal>
    );
};
